import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, delay = 0, onView = false, stagger = 0.12 }) =>
  lines.map((line, i) => (
    <motion.span
      key={i}
      className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
      initial="hidden"
      {...(onView
        ? { whileInView: "show", viewport: { once: true, amount: 0.4 } }
        : { animate: "show" })}
      variants={{ hidden: {}, show: {} }}
      transition={{ delayChildren: delay + i * stagger }}
    >
      <motion.span
        className="block will-change-transform"
        variants={{ hidden: { y: "115%" }, show: { y: "0%" } }}
        transition={{ duration: 1.05, ease: EASE }}
      >
        {line}
      </motion.span>
    </motion.span>
  ));

export const RevealImage = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial={{ clipPath: "inset(14% 10% 14% 10% round 28px)", opacity: 0.35, scale: 1.07 }}
    whileInView={{ clipPath: "inset(0% 0% 0% 0% round 28px)", opacity: 1, scale: 1 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 1.2, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
